import React, { useState } from "react"

interface InfoTooltipProps {
  id: string
  message?: string
  placement?: "top" | "bottom"
  label?: string
}

export default function InfoTooltip({
  id,
  message,
  placement = "top",
  label = "More information",
}: InfoTooltipProps) {
  const [visible, setVisible] = useState(false)

  if (!message) {
    return null
  }

  return (
    <span
      className="infotip-wrapper"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <button
        type="button"
        className="infotip infotip-trigger glyphicon glyphicon-info-sign"
        aria-label={label}
        aria-describedby={id}
        onFocus={() => setVisible(true)}
        onBlur={() => setVisible(false)}
        onKeyDown={(event: React.KeyboardEvent<HTMLButtonElement>) => {
          if (event.key === "Escape") {
            setVisible(false)
          }
        }}
      />
      {visible && (
        <span className={`tooltip in ${placement}`} aria-hidden="true">
          <span className="tooltip-arrow" />
          <span className="tooltip-inner">{message}</span>
        </span>
      )}
      <span id={id} className="sr-only" aria-hidden="true">
        {message}
      </span>
    </span>
  )
}
